import type { FC } from "react";

import { Controller, type UseFormReturn } from "react-hook-form";

import { Alert, Button, Input, Text } from "@alpacahq/ui/old";

import { Field } from "~/v2/components/form";
import { getPrettyAmount, getPrettyCash } from "../../../../utils/formatting";
import { getCashTransformerV2 } from "../common/util";
import { getCorrectAmount, type TransferSchema } from "./schema";

const QUICK_AMOUNT_VALUES = [500, 1000, 10000];

type TransferFormProps = {
  form: UseFormReturn<TransferSchema>;
  withdrawableAmount?: number;
  isInputDisabled?: boolean;
};

export const TransferFormFields: FC<TransferFormProps> = ({
  form,
  withdrawableAmount,
  isInputDisabled,
}) => {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = form;

  const amount = getCorrectAmount(watch("amount"));
  const amountString = getPrettyAmount(amount);

  const isWithdrawableAmountDefined = typeof withdrawableAmount !== "undefined";
  const isWithdrawalInvalid = isWithdrawableAmountDefined
    ? amount > 0 && amount > withdrawableAmount
    : false;
  const withdrawableString = isWithdrawableAmountDefined
    ? getPrettyCash(withdrawableAmount, {
        acceptZero: true,
      })
    : "";

  const onQuickAmountClicked = (amount: string) => () => {
    setValue("amount", amount, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <>
      <div>
        <Field label={"Amount"} error={!!errors.amount}>
          <Controller
            name={"amount"}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input
                disabled={isInputDisabled}
                leftIcon={<Text>$</Text>}
                {...(isWithdrawableAmountDefined && {
                  rightIcon: (
                    <Text className="text-gray-500">
                      {withdrawableString} available to withdraw
                    </Text>
                  ),
                })}
                {...getCashTransformerV2({ field })}
              />

              // <InputGroup>
              //   <InputLeftElement>
              //     <Text>$</Text>
              //   </InputLeftElement>
              //   <Input
              //     disabled={isInputDisabled}
              //     {...getCashTransformerV2({ field })}
              //   />
              //   {isWithdrawableAmountDefined && (
              //     <InputRightElement pr="1rem" width="unset">
              //       <Text className="text-gray-500">
              //         {withdrawableString} available to withdraw
              //       </Text>
              //     </InputRightElement>
              //   )}
              // </InputGroup>
            )}
          />
        </Field>
        {isWithdrawalInvalid && (
          <Alert
            variant="danger"
            message={`Cannot withdraw more than ${withdrawableString}. Some deposits take
            up to 7 days to settle, after which they will be made available for
            withdrawal.`}
            className="mt-2"
          />
        )}
      </div>
      <div className="flex gap-4 py-4">
        {QUICK_AMOUNT_VALUES.map((value) => {
          const quickAmount = getPrettyAmount(value);

          return (
            <Button
              key={value}
              type="button"
              onClick={onQuickAmountClicked(quickAmount)}
              variant={quickAmount === amountString ? "default" : "secondary"}
              disabled={isInputDisabled}
            >
              ${quickAmount}
            </Button>
          );
        })}
      </div>
    </>
  );
};
